import React from 'react';
import { Item } from 'semantic-ui-react';

import mapConnection from '../../../../../utils/connectionMapper';
import { isCrmStateMoveable } from '../../../../../utils/passengersMoveableCrmStates';
import PassengerView from '../../../../PassengerView';

const ListView = ({
  claimsPassengerTickets,
  passengerTicketId,
  onClaimUpdated,
  onRemovePassenger,
  onContactPersonChange,
  previewOnly,
  paymentData,
  crmState,
  paxBankAccountHolder,
  donatedAmount
}) => {
  return claimsPassengerTickets
    ? claimsPassengerTickets.map(claimPassengerTicket => {
        const isContactPerson =
          passengerTicketId === claimPassengerTicket.passengerTicket.id;
        const isPassengerRemovable =
          isCrmStateMoveable(crmState) && !isContactPerson;
        return (
          <Item key={claimPassengerTicket.id}>
            <Item.Content>
              <PassengerView
                removable={isPassengerRemovable}
                contactPerson={isContactPerson}
                payment={paymentData}
                passenger={claimPassengerTicket.passengerTicket}
                promoCode={claimPassengerTicket.promoCode}
                loa={claimPassengerTicket.loa}
                documents={mapConnection(
                  claimPassengerTicket.documentsConnection
                )}
                onClaimUpdated={onClaimUpdated}
                onRemovePassenger={onRemovePassenger}
                onContactPersonChange={onContactPersonChange}
                previewOnly={previewOnly}
                paxBankAccountHolder={paxBankAccountHolder}
                donatedAmount={donatedAmount}
                contact
              />
            </Item.Content>
            <br />
          </Item>
        );
      })
    : null;
};

export default ListView;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimDetails/Passengers/PassengersList/ListView.js